import { initHomeCarousels } from "./carousels.js";
import { initHomeNewsletter } from "./newsletter.js";
import { initHeroSearch } from "./hero_search.js";

function boot() {
  initHeroSearch();
  initHomeCarousels();
  initHomeNewsletter();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", boot);
} else {
  boot();
}
